var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / GG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-GG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#E8112D",
    mask: "url(#mask-2)",
    x: 10.6666667,
    y: 0,
    width: 6.66666667,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#E8112D",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#F9DD16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.666667, 2.666667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1229",
    x: 6.66666667,
    y: 0,
    width: 1.33333333,
    height: 14.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-1",
    points: "7.33333333 13.3333333 8.66666667 14.6666667 6 14.6666667"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1229",
    x: 0,
    y: 6.66666667,
    width: 14.6666667,
    height: 1.33333333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-1",
    transform: "translate(7.333333, 0.666667) scale(1, -1) translate(-7.333333, -0.666667) ",
    points: "7.33333333 0 8.66666667 1.33333333 6 1.33333333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-1",
    transform: "translate(0.666667, 7.333333) scale(1, -1) rotate(-270.000000) translate(-0.666667, -7.333333) ",
    points: "0.666666667 6.66666667 2 8 -0.666666667 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-1",
    transform: "translate(14.000000, 7.333333) scale(-1, -1) rotate(-270.000000) translate(-14.000000, -7.333333) ",
    points: "14 6.66666667 15.3333333 8 12.6666667 8"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/GG.f8df3ad0630feaa9716f10a36104ddd2.svg";
export { ForwardRef as ReactComponent };